const buildTimesheetListUrl = (page, limit, search, jobStatus, fromDate, toDate) => {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  if (jobStatus) params.set('jobStatus', jobStatus);
  if (fromDate) params.set('fromDate', fromDate);
  if (toDate) params.set('toDate', toDate);
  params.set('page', page);
  params.set('limit', limit);
  return `api/v1/admin/getAllStaffBooking?${params.toString()}`;
};

const buildTimesheetDownloadUrl = (fromDate, toDate, jobStatus) => {
  const params = new URLSearchParams();
  if (fromDate) params.set('fromDate', fromDate);
  if (toDate) params.set('toDate', toDate);
  if (jobStatus) params.set('jobStatus', jobStatus);
  return `api/v1/downloadStaffBooking?${params.toString()}`;
};

export { buildTimesheetDownloadUrl, buildTimesheetListUrl };
